module.exports = __webpack_public_path__ + "img/logoAngular.daacb4a9.svg";